/* istanbul ignore file */

import { Page } from '../pages.model';
import { ProductDetailsPage } from './product-details.model';

const ProductDetails: React.FC<{ data: Page }> = ({ data }) => {
  const pageData = data as ProductDetailsPage;
  return (
    <>
      <div>
        <b
          style={{
            marginBottom: '20px',
            fontSize: '20px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          Product Details Page
        </b>
      </div>
      <div
        style={{
          wordBreak: 'break-all',
        }}
      >
        {JSON.stringify(pageData)}
      </div>
    </>
  );
};

export default ProductDetails;
